import PropTypes from "prop-types";
import * as React from "react";
import { normalizePassword } from "../../../shared/auth/password.js";
import { routePath } from "../../../shared/routes/index.js";
import { supportsPasskeys } from "../../services/passkeys";
import { Box, Button, Divider, Link, TextInput } from "../../themeV2";
import AccountChip from "./AccountChip";

export default function CredentialsStep({
  email,
  onPassword,
  onPasskey,
  onChangeAccount,
  isSubmitting,
}) {
  const [password, setPassword] = React.useState("");
  const [problem, setProblem] = React.useState(null);

  const handleSubmit = (event) => {
    event.preventDefault();

    return normalizePassword(password)
      ? onPassword(normalizePassword(password))
      : setProblem("Please enter your password");
  };

  return (
    <Box direction="column" gap={4}>
      <AccountChip email={email} onChange={onChangeAccount} />

      <form onSubmit={handleSubmit} noValidate>
        <Box direction="column" gap={4}>
          <input
            type="email"
            name="username"
            autoComplete="username"
            value={email}
            readOnly
            hidden
          />
          <TextInput
            type="password"
            label="Password"
            variant="filled"
            autoComplete="current-password"
            autoFocus
            required
            value={password}
            onValueChange={setPassword}
            error={problem ?? undefined}
          />

          <Button type="submit" fullWidth loading={isSubmitting}>
            Log In
          </Button>

          <Link to={routePath("auth.reset-password")}>
            Forgot your password?
          </Link>
        </Box>
      </form>

      {supportsPasskeys() && (
        <>
          <Divider />
          <Button variant="outlined" fullWidth onClick={onPasskey}>
            Sign in with a passkey
          </Button>
        </>
      )}
    </Box>
  );
}

CredentialsStep.propTypes = {
  email: PropTypes.string.isRequired,
  onPassword: PropTypes.func.isRequired,
  onPasskey: PropTypes.func.isRequired,
  onChangeAccount: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool,
};
